export default {}



// WEBPACK FOOTER //
// ./src/api/modules/prescription.js